module.exports = __webpack_public_path__ + "agile.2tuij4Kn.svg";